export function download(url: string, filename: string): void
export function download(file: Blob, filename: string): void
export function download(file: string | Blob, filename: string) {
  const url = file instanceof Blob ? window.URL.createObjectURL(file) : file
  const ele = document.createElement('a')
  ele.href = url
  ele.download = filename
  ele.click()
  if (file instanceof Blob) window.URL.revokeObjectURL(url)
}
